import { i18n } from 'src/i18n';
import AssetService from 'src/modules/asset/assetService';
import exporterFields from 'src/modules/asset/list/assetListExporterFields';
import selectors from 'src/modules/asset/list/assetListSelectors';
import Errors from 'src/modules/shared/error/errors';
import Exporter from 'src/modules/shared/exporter/exporter';

const prefix = 'ASSET_LIST';

let latestFetchToken = 0;

const assetListActions = {
  FETCH_STARTED: `${prefix}_FETCH_STARTED`,
  FETCH_SUCCESS: `${prefix}_FETCH_SUCCESS`,
  FETCH_ERROR: `${prefix}_FETCH_ERROR`,

  RESETED: `${prefix}_RESETED`,
  SELECTEDS_CHANGED: `${prefix}_SELECTEDS_CHANGED`,

  PAGINATION_CHANGED: `${prefix}_PAGINATION_CHANGED`,
  SORTER_CHANGED: `${prefix}_SORTER_CHANGED`,

  EXPORT_STARTED: `${prefix}_EXPORT_STARTED`,
  EXPORT_SUCCESS: `${prefix}_EXPORT_SUCCESS`,
  EXPORT_ERROR: `${prefix}_EXPORT_ERROR`,

  TEMPLATES_FETCH_STARTED: `${prefix}_TEMPLATES_FETCH_STARTED`,
  TEMPLATES_FETCH_SUCCESS: `${prefix}_TEMPLATES_FETCH_SUCCESS`,
  TEMPLATES_FETCH_ERROR: `${prefix}_TEMPLATES_FETCH_ERROR`,

  doFetchTemplates: () => async (dispatch) => {
    try {
      dispatch({
        type: assetListActions.TEMPLATES_FETCH_STARTED,
      });

      const rows = await AssetService.listTemplates();

      dispatch({
        type: assetListActions.TEMPLATES_FETCH_SUCCESS,
        payload: rows || [],
      });
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: assetListActions.TEMPLATES_FETCH_ERROR,
      });
    }
  },

  doChangeSelected(payload) {
    return {
      type: assetListActions.SELECTEDS_CHANGED,
      payload,
    };
  },

  doReset: () => async (dispatch) => {
    dispatch({
      type: assetListActions.RESETED,
    });

    dispatch(assetListActions.doFetch());
  },

  doExport: () => async (dispatch, getState) => {
    try {
      if (!exporterFields || !exporterFields.length) {
        throw new Error('exporterFields is required');
      }

      dispatch({
        type: assetListActions.EXPORT_STARTED,
      });

      const filter = selectors.selectFilter(getState());
      const response = await AssetService.list(
        filter,
        selectors.selectOrderBy(getState()),
        null,
        null,
      );

      new Exporter(
        exporterFields,
        i18n('entities.asset.exporterFileName'),
      ).transformAndExportAsExcelFile(response.rows);

      dispatch({
        type: assetListActions.EXPORT_SUCCESS,
      });
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: assetListActions.EXPORT_ERROR,
      });
    }
  },

  doChangePaginationAndSort:
    (pagination, sorter) => async (dispatch, _getState) => {
      dispatch({
        type: assetListActions.PAGINATION_CHANGED,
        payload: pagination,
      });

      dispatch({
        type: assetListActions.SORTER_CHANGED,
        payload: sorter,
      });

      dispatch(assetListActions.doFetchCurrentFilter());
    },

  doFetchCurrentFilter:
    () => async (dispatch, getState) => {
      const filter = selectors.selectFilter(getState());
      const rawFilter = selectors.selectRawFilter(
        getState(),
      );
      dispatch(
        assetListActions.doFetch(filter, rawFilter, true),
      );
    },

  doFetch:
    (filter?, rawFilter?, keepPagination = false) =>
    async (dispatch, getState) => {
      const token = ++latestFetchToken;
      try {
        dispatch({
          type: assetListActions.FETCH_STARTED,
          payload: { filter, rawFilter, keepPagination },
        });

        const response = await AssetService.list(
          filter,
          selectors.selectOrderBy(getState()),
          selectors.selectLimit(getState()),
          selectors.selectOffset(getState()),
        );

        if (token !== latestFetchToken) {
          return;
        }

        dispatch({
          type: assetListActions.FETCH_SUCCESS,
          payload: {
            rows: response.rows,
            count: response.count,
          },
        });
      } catch (error) {
        if (token !== latestFetchToken) {
          return;
        }
        Errors.handle(error);

        dispatch({
          type: assetListActions.FETCH_ERROR,
        });
      }
    },
  doCopyFetch:
    (filter?, rawFilter?, _keepPagination = false) =>
    async (dispatch, getState) => {
      try {
        const response = await AssetService.list(
          filter,
          selectors.selectOrderBy(getState()),
          selectors.selectLimit(getState()),
          selectors.selectOffset(getState()),
        );

        dispatch({
          type: assetListActions.FETCH_SUCCESS,
          payload: {
            rows: response.rows,
            count: response.count,
          },
        });
      } catch (error) {
        Errors.handle(error);

        dispatch({
          type: assetListActions.FETCH_ERROR,
        });
      }
    },
};

export default assetListActions;
